import styled from 'styled-components'

import { colors, fonts } from 'stylesheets'

export const Container = styled.div`
  display: flex;
  justify-content: left;
  align-items: left;
  margin: 20px 0;
  background: ${colors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;

  a {
    text-decoration: none;
  }
`

export const Amount = styled.div`
  height: auto;
  display: block;
  min-width: 125px;
  justify-content: space-between;
  align-self: center;
  padding: 41px 20px;
  background: bisque;
  color: black;
`

export const TypeService = styled.div`
  padding: ${({ padding }) => padding || '20px 40px'};
  width: ${({ width }) => width || '100%'};
  text-align: center;
  display: inline-block;
`
export const Text = styled.h4`
  font-family: ${({ primary }) => primary ? `${fonts.primary}` : `${fonts.secondary}`};
  font-size: ${({ fontsize }) => fontsize || '12'}px;
  margin-top: ${({ margintop }) => margintop || '0'}px;
  margin-bottom: ${({ marginbottom }) => marginbottom || '.5rem'};
  margin-left: ${({ marginleft }) => marginleft || 0}px;
  color: ${({ color }) => color || `${colors.greyDark}`};
  font-weight: ${({ bold }) => bold ? 'bold' : 'normal'};
  white-space: ${({ oneline }) => oneline ? 'nowrap' : 'normal'};
  cursor: ${({ button }) => button ? 'pointer' : 'initial'};
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-right: 10px;
  }
`

export const Document = styled.div`
  width: 100%;
`

export const Icon = styled.img`
  width: ${({ width }) => width || '15'}px;
  height: ${({ height }) => height || '15' }px;
  margin-right: ${({ marginright }) => marginright || 10}px;
  margin-bottom: ${({ marginbottom }) => marginbottom || 0}px;
`
